import { Component, inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';
import { LibraryPage, ReportConfig } from '@modules/report-generator/interfaces';

interface AddPageDialogData {
  pageLibrary: LibraryPage[];
  reportConfig?: ReportConfig;
}

type DialogView = 'grid' | 'detail';

@Component({
  selector: 'app-add-page-dialog',
  templateUrl: './add-page-dialog.component.html',
  styleUrls: ['./add-page-dialog.component.scss'],
})
export class AddPageDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<AddPageDialogComponent>);
  private readonly data = inject<AddPageDialogData>(MAT_DIALOG_DATA);

  readonly pageLibrary = this.data.pageLibrary;
  readonly reportConfig = this.data.reportConfig;

  currentView: DialogView = 'grid';
  selectedPage?: LibraryPage;
  selectedChip = 'all';

  onChipSelected(chip: string): void {
    this.selectedChip = chip;
  }

  onPageSelected(page: LibraryPage): void {
    this.selectedPage = page;
    this.currentView = 'detail';
  }

  onBack(): void {
    this.currentView = 'grid';
    this.selectedPage = undefined;
  }

  onPageInsert(pageId: number): void {
    this.dialogRef.close(pageId);
  }

  get testType(): string | undefined {
    const testType = this.reportConfig?.test?.test_type;
    if (!testType) {
      return testType;
    }

    return ['newtype', 'map', 'ppd'].includes(testType) ? 'ppd' : testType;
  }
}
